const STORY_SORT_OPTIONS = [
  {
    label: 'Date',
    value: 'date'
  },
  {
    label: 'Author',
    value: 'author'
  },
  {
    label: 'Media Outlet',
    value: 'media_outlet'
  },
  {
    label: 'Title',
    value: 'title'
  }
];

const STORY_ANALYTICS_OPTIONS = [
  {
    label: 'Total Shares',
    value: 'shares'
  },
  {
    label: 'Impressions',
    value: 'impression'
  },
  {
    label: 'Followers (Twitter)',
    value: 'followers'
  },
  {
    label: 'Retweets (Twitter)',
    value: 'retweets'
  }
];

// This is commented until we can figure out a better way to display MQS in Reading List please keep it here
// const MEDIA_QUALITY_SCORE_OPTION = {
//   label: 'Media Quality Score',
//   value: 'media_score'
// };

// const STORY_IMPACT_OPTIONS = [
//   MEDIA_QUALITY_SCORE_OPTION,
//   {
//     label: 'Prominence',
//     value: 'prominence'
//   },
//   {
//     label: 'Frequency',
//     value: 'frequency'
//   },
//   {
//     label: 'Reach',
//     value: 'reach'
//   }
// ];

export const SORT_OPTIONS = [
  // This is commented until we can figure out a better way to display MQS in Reading List please keep it here
  // { label: 'Story Impact', options: STORY_IMPACT_OPTIONS }
  { label: 'Story Information', options: STORY_SORT_OPTIONS },
  { label: 'Story Analytics', options: STORY_ANALYTICS_OPTIONS }
];

export const ORDER_OPTIONS = [{ value: 'asc', label: 'Ascending' }, { value: 'desc', label: 'Descending' }];

// This is commented until we can figure out a better way to display MQS in Reading List please keep it here
export const getSortOptions = (/*isMediaScoreEnabled*/) => {
  return SORT_OPTIONS; // isMediaScoreEnabled? SORT_OPTIONS : SORT_OPTIONS.slice(0, -1);
};
